
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.164.664L5.617 2.04H6.93V12H1.664l-.547 1.375H.211L.758 12H.07v-1.086h1.117l1.407-3.539H.156V6.281h2.867l1.258-3.156H.071V2.039h4.64L5.258.664h.906zm-.976 2.461L3.93 6.281h1.78V3.125h-.522zM3.5 7.375l-1.406 3.54H5.71v-3.54H3.5z","fill":"currentColor"}})])
          )
        }
      }
    